export const encryptStringPrefix = "04";
export const sm2PublicKey = "03ea2db5871276f0f7d860895162f263f78fb6f3cd16749735af21e514f508cdc8";
export const sm4Key = "c391893b4706898311972ada803503e3";
export const isEncrypt = true;//是否需要加解密